import axios from "axios";
const instance = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? "https://player.ukpl.co.uk/api" : "http://localhost/api",
  //baseURL: "https://player.ukpl.co.uk/api",
  headers: {
    "Content-Type": "application/json",
  },
});
export default instance;
